/**
 * Hook tự động xác định permKey dựa vào URL hiện tại
 * và trả về canEdit / canView cho trang đó.
 */
import { useLocation } from 'react-router-dom'
import { usePermission } from './usePermission'

const ROUTE_PERM_MAP: Array<{ prefix: string; permKey: string }> = [
  { prefix: '/purchase/contract', permKey: 'purchase' },
  { prefix: '/purchase/refs',     permKey: 'purchase' },
  { prefix: '/vendors',           permKey: 'purchase' },
  { prefix: '/procurement',       permKey: 'procurement' },
  { prefix: '/sales/contract',    permKey: 'saleContract' },
  { prefix: '/sales/control',     permKey: 'saleControl' },
  { prefix: '/futures',           permKey: 'futures' },
  { prefix: '/factory',           permKey: 'factory' },
  { prefix: '/matching',          permKey: 'matchingPs' },
  { prefix: '/quality',           permKey: 'quality' },
  { prefix: '/virtual-warehouse', permKey: 'virtualWarehouse' },
  { prefix: '/master-data',       permKey: 'masterData' },
  { prefix: '/settings',          permKey: 'setting' },
]

export function usePagePermission() {
  const { pathname } = useLocation()
  const permKey = ROUTE_PERM_MAP.find((m) => pathname.startsWith(m.prefix))?.permKey
  return usePermission(permKey)
}
